import fr from 'facet-rest';
import BaseOverride from 'Overrides/OnboardingStep/BaseOverride';
import MultiFactorAuthenticationCodeInput from 'Components/ComponentLibrary/Components/Inputs/MultiFactorAuthenticationCode';

const VerifyTwoFactorCodeOverride = fr.metaOverride({ base: BaseOverride })
  .nameOverride('verificationCode', {
    _component: () => MultiFactorAuthenticationCodeInput,
  });

export default VerifyTwoFactorCodeOverride;
